import CalendarWithLabel from './CalendarWithLabel';

export default CalendarWithLabel;
